import './search.scss';
(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.tink_search = {
    attach: function (context, settings) {
      $(document).ready(function(){
        setTimeout( function(){
          $('#sr__counter').focus();
        }, 200);
      });
    }
  };
})(jQuery, Drupal);
